import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PwaService {

  promptIntercepted = false;
  isStandalone = false;
  deferredPrompt : any;
  userInstalled = false;
  whereIsShare = 'bottom';

  isChrome = false;
  isExplorer = false;
  isExplorer_11 = false;
  isFirefox = false;
  isSafari = false;
  isOpera = false;
  isEdgeDesktop = false;
  isEdgeiOS = false;
  isEdgeAndroid = false;
  userAgent = '';

  isIOS = false;
  isMobile = false;
  showIOSPopupManually = false;
  promptSaved = false;
  customButtonClicked = false;
  deferredPromptShown = false;
  deferredPromptRejected = false;


  constructor() {
  
  }

  checkUserAgent() {
    this.userAgent = navigator.userAgent.toLowerCase();
    const uaString = this.userAgent;

    this.isChrome = /chrome/.test(uaString);
    this.isExplorer = /msie/.test(uaString);
    this.isExplorer_11 = /rv:11/.test(uaString);
    this.isFirefox = /firefox/.test(uaString);
    this.isSafari = /safari/.test(uaString);
    this.isOpera = /opr/.test(uaString);
    this.isEdgeDesktop = /edge/.test(uaString);
    this.isEdgeiOS = /edgios/.test(uaString);
    this.isEdgeAndroid = /edga/.test(uaString);

    this.isIOS = /ipad|iphone|ipod/.test(uaString);
    this.isMobile = /mobile/.test(uaString);
    if ((this.isChrome) && (this.isSafari)) {
      this.isSafari = false;
    }
    if ((this.isChrome) && ((this.isEdgeDesktop) ||
      (this.isEdgeiOS) ||
      (this.isEdgeAndroid))) {
      this.isChrome = false;
    }
    if ((this.isSafari) && ((this.isEdgeDesktop) ||
      (this.isEdgeiOS) ||
      (this.isEdgeAndroid))) {
      this.isSafari = false;
    }
    if ((this.isChrome) && (this.isOpera)) {
      this.isChrome = false;
    }

    if (/ipad/.test(uaString)) {
      this.whereIsShare = 'top';
    }

  }

  // showUserAgent() {
  //   this.userAgent = navigator.userAgent.toLowerCase();
  // }



  clearStorageKeepingPwaSettings(): void {

  const settings = {
    pwaNextShowDate:
      localStorage.getItem('PwaNextShowDate'),

    pwaInstalled:
      localStorage.getItem('PwaInstalled')
  };

  localStorage.clear();

  if (settings.pwaNextShowDate) {
    localStorage.setItem(
      'PwaNextShowDate',
      settings.pwaNextShowDate
    );
  }

  if (settings.pwaInstalled) {
    localStorage.setItem(
      'PwaInstalled',
      settings.pwaInstalled
    );
  }
}
  trackStandalone() {
  this.isStandalone = this.checkStandalone();
  
  if (
    localStorage.getItem('PwaInstalled') === 'true'
    &&
    !this.isStandalone
  ) {

    localStorage.removeItem('PwaInstalled');

  }

  }

  checkStandalone(): boolean {
    return (window.matchMedia('(display-mode: standalone)').matches)
    ||
    (window.navigator as any).standalone === true
;
  }

  trackInstalled() {
    // this.userInstalled = true;  
    localStorage.setItem('PwaInstalled','true');
    
    localStorage.removeItem(
      'PwaNextShowDate'
  );

  }

  addToHomeScreen() {
    // chama o botão de instalar
    this.customButtonClicked = true;

    if (!this.deferredPrompt) {
      return;
    }

    this.deferredPrompt.prompt();
    this.deferredPromptShown = true;

    this.deferredPrompt.userChoice
      .then((choiceResult : any) => {

        if (choiceResult.outcome === 'accepted') {

        } else {
          this.deferredPromptRejected = true;
        }

      });
  }

  showHide(checkWhat: boolean) {
    if (checkWhat) {
      return 'block';
    } else {
      return 'none';
    }
  }

    showInstallButton(): boolean {


  if (this.checkStandalone()) {
    return false;
  }

  if (localStorage.getItem('PwaInstalled') === 'true') {
    return false;
  }

    return localStorage.getItem('PwaNextShowDate') !== null;

      }

  browserPromptBtn() {
    
  return (
    this.promptIntercepted &&
    !this.isStandalone &&
    this.canShowPwaPopup()
  );

    // let pwaNoInstall = localStorage.getItem('NoInstallPwa');

    // if (this.promptIntercepted && !this.userInstalled && this.canShowPwaPopup()) {
    //   return true;
    // }
    // return false;
  }

  browserPromptBtniOS() {
    
      if (this.showIOSPopupManually) {
        return true;
      }

    return (
        this.isSafari &&
        !this.isStandalone &&
        this.canShowPwaPopup()
      );

    // let pwaNoInstall = localStorage.getItem('NoInstallPwa');

    // if (this.isSafari && !this.isStandalone && pwaNoInstall == null && this.canShowPwaPopup()) {
    //   return true;
    // }
    // return false;
  }

openInstallGuide() {

  this.showIOSPopupManually = true;
}


  closePrompt() {

    if (this.showIOSPopupManually) {

      this.showIOSPopupManually = false;

      return;
    }

    this.promptIntercepted = false;
  //  this.userInstalled = true;

    const nextShowDate = new Date();
    nextShowDate.setDate(nextShowDate.getDate() + 60);

    localStorage.setItem('PwaNextShowDate',nextShowDate.toISOString());

  }
  
    installAction() {

      if (this.isSafari) {

        this.openInstallGuide();

        return;
      }

      this.addToHomeScreen();
    }


  canShowPwaPopup(): boolean {

    const nextShowDate = localStorage.getItem('PwaNextShowDate');

    if (!nextShowDate) {
      return true;
    }

    return new Date() >= new Date(nextShowDate);
  }

  iOSSfaariHow2() {
    if (this.isSafari && this.isIOS && !this.isStandalone) {
      return 'block';
    } else {
      return 'none';
    }
  }


  showHideButton_iOS() {
    if (this.isIOS && !this.userInstalled) {
      return 'block';
    } else {
      return 'none';
    }
  }

  trueOrFalse(checkWhat: boolean) {
    if (checkWhat) {
      return 'green';
    } else {
      return 'red';
    }
  }

}
